const SURPLUS_WASTE_FACTOR = 4.750943;
const DONATION_COST_FACTOR = 0.390236;

const lbsToMT = (x) => x * 0.0005;

/**
 * @deprecated See {getImapact}
 *
 * Converts food rescued weight (lbs) to
 * CO2 saved in Metric Tons
 * @param {*} weightInLbs
 * @returns CO2 saved in metric tons
 */
const getTotalCO2Saved = (weightInLbs) =>
  lbsToMT(weightInLbs) * SURPLUS_WASTE_FACTOR -
  lbsToMT(weightInLbs) * DONATION_COST_FACTOR;

/**
 *
 *
 * @param {object} params
 * @param {string} params.businessType
 * @param {"ghg" | "water"} params.impact
 * @param {string} params.foodType
 * @param {string?} params.destination
 * @param {number} params.weight
 * @returns {number}
 */
const getImpact = ({
  businessType,
  impact,
  foodType,
  destination: dest_,
  weight,
}) => {
  const donation = 0;
  const compost = 1;
  const landfill = 2;

  let destination;
  let refedFoodType;

  switch (foodType) {
    case 'non_perishable_weight':
    case 'dairy_weight':
    case 'produce_weight':
    case 'meat_weight':
    case 'baked_weight':
    case 'beverages_weight':
    case 'prepared_weight':
    case 'frozen_weight':
    case 'animal_feed_weight':
      destination = donation;
      break;

    case 'compost_weight':
      destination = compost;
      break;

    case 'unusable_weight':
      destination = landfill;
      break;

    case 'non_food_weight':
      return 0;

    default:
      throw new Error('Unreachable');
  }
  if (dest_) {
    destination = {
      donation: 0,
      compost: 1,
      landfill: 2,
    }[dest_];
  }

  switch (foodType) {
    case 'non_perishable_weight':
    case 'compost_weight':
    case 'unusable_weight':
    case 'animal_feed_weight':
      refedFoodType = 'Dry Goods';
      break;
    case 'dairy_weight':
      refedFoodType = 'Dairy & Eggs';
      break;
    case 'produce_weight':
      refedFoodType = 'Produce';
      break;
    case 'meat_weight':
      refedFoodType = 'Fresh Meat & Seafood';
      break;
    case 'baked_weight':
      refedFoodType = 'Breads & Bakery';
      break;
    case 'beverages_weight':
      refedFoodType = 'Ready-To-Drink Beverages';
      break;
    case 'prepared_weight':
      refedFoodType = 'Prepared Foods';
      break;
    case 'frozen_weight':
      refedFoodType = 'Frozen';
      break;

    case 'non_food_weight':
    default:
      throw new Error('Unreachable');
  }

  const sector =
    {
      Restaurant: 'foodservice',
      'Grocery Store': 'retail',
      'Caterer or Food Services': 'foodservice',
      'Corp - onsite cafeteria': 'foodservice',
      'Corp - catered meals': 'foodservice',
      'Bakery /Dessert': 'foodservice',
      'Cafe / Coffee Shop': 'foodservice',
      'School / Education': 'foodservice',
      'Farm or Farmers Market': 'foodservice',
      'Home Growers': 'foodservice',
      Hotel: 'foodservice',
      Hospital: 'foodservice',
      'Retail Store': 'retail',
      'Special Events': 'foodservice',
      Wholesaler: 'retail',
      'NPO/Agency': 'foodservice',
      Other: 'foodservice',
    }[businessType] ?? 'foodservice';

  // Taken from https://insights-engine.refed.org/impact-calculator
  const coefficients = {
    foodservice: {
      ghg: {
        Produce: [0.8868675484, 1.7835674508, 2.0209644039],
        'Dry Goods': [1.6309887601, 3.2408805823, 4.1861700796],
        'Dairy & Eggs': [2.4265205886, 4.8530423694, 5.2783794555],
        Frozen: [2.766722, 5.51898, 6.312431],
        'Fresh Meat & Seafood': [7.3934428466, 14.7772289701, 15.4607137576],
        'Ready-To-Drink Beverages': [2.1598772832, 4.3022990594, 5.1642339468],
        'Breads & Bakery': [1.2632409774, 2.4837579233, 3.9239965261],
        'Prepared Foods': [2.3394184215, 4.6682752583, 5.3688880323],
      },
      water: {
        Produce: [11.3223245043285, 22.644649008657048, 22.644649008657048],
        'Dry Goods': [31.030328140597, 62.060656281194, 62.060656281194],
        'Dairy & Eggs': [
          71.70868471750481, 143.41736943500968, 143.41736943500968,
        ],
        Frozen: [85.20859175642215, 170.4171835128443, 170.4171835128443],
        'Fresh Meat & Seafood': [
          294.8792843365193, 589.7585686730386, 589.7585686730386,
        ],
        'Ready-To-Drink Beverages': [
          6.75423131172855, 13.50846262345705, 13.50846262345705,
        ],
        'Breads & Bakery': [
          4.8451083374116, 9.69021667482315, 9.69021667482315,
        ],
        'Prepared Foods': [
          118.7358297685051, 237.4716595370102, 237.4716595370102,
        ],
      },
    },
    retail: {
      ghg: {
        Produce: [0.694306579, 1.3959941594, 1.6894917193],
        'Dry Goods': [1.9363656732, 3.8433753327, 4.8561104293],
        'Dairy & Eggs': [1.9380006015, 3.8683956507, 4.2020612016],
        Frozen: [3.5273004518, 7.0432806914, 7.7647969288],
        'Fresh Meat & Seafood': [6.7031616452, 13.3951727303, 14.1128153842],
        'Ready-To-Drink Beverages': [1.46096168, 2.934583786, 3.107245541],
        'Breads & Bakery': [1.5054101527, 2.9673688514, 4.424255538],
        'Prepared Foods': [3.6789082625, 7.3470943525, 8.0549273371],
      },
      water: {
        Produce: [10.10667036851485, 20.2133407370297, 20.2133407370297],
        'Dry Goods': [32.2129502332401, 64.4259004664802, 64.4259004664802],
        'Dairy & Eggs': [
          63.71022023436265, 127.42044046872536, 127.42044046872536,
        ],
        Frozen: [69.99592164383876, 139.9918432876775, 139.9918432876775],
        'Fresh Meat & Seafood': [
          338.7187385174852, 677.4374770349704, 677.4374770349704,
        ],
        'Ready-To-Drink Beverages': [
          4.1404803217326, 8.2809606434652, 8.2809606434652,
        ],
        'Breads & Bakery': [
          4.8451083374116, 9.69021667482315, 9.69021667482315,
        ],
        'Prepared Foods': [
          106.13817227367305, 212.2763445473461, 212.2763445473461,
        ],
      },
    },
  };

  return coefficients[sector][impact][refedFoodType][destination] * weight;
};

module.exports = {
  getTotalCO2Saved,
  getImpact,
};
